function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-chaudiere");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-chaudiere"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(5.000000, 6.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 20,
  height: 18
})), /*#__PURE__*/React.createElement("path", {
  d: "M15,1.5 C22.4558441,1.5 28.5,7.54415588 28.5,15 C28.5,22.4558441 22.4558441,28.5 15,28.5 C7.54415588,28.5 1.5,22.4558441 1.5,15 C1.5,7.54415588 7.54415588,1.5 15,1.5 Z M15.7045829,6 C12.8245747,8.88000817 11.0039512,13.4591026 11.5,18 C10.7559268,17.060504 9.49999999,16.2829134 9.49999999,15.5 C8.05692307,22.234359 14.8745077,23.9142979 15.5037989,23.9971105 L15.5,24 C15.5298364,24.0004367 15.5440054,24.0010982 15.5484943,23.9996673 C15.7243947,23.8963757 15.891972,23.7922605 16.0515237,23.6873118 C21.5686748,20.3744832 20.9064449,14.8440748 18,10 C18.3491253,11.3965011 18.3071493,13.3226114 18.0496532,15.3087397 C17.1149437,12.5874831 15.7045829,9.50529566 15.7045829,6 Z M15.1095783,17.6028657 C16.5469057,19.4920618 16.6724103,20.9265862 15.4860922,21.906439 C13.8109678,21.2645363 13.6854631,19.8300119 15.1095783,17.6028657 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30Chaudiere = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Chaudiere, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-chaudiere.70b96497.svg";
export { ForwardRef as ReactComponent };